<template>
  <div class="product-search-form">
    <el-form
      :model="form"
      class="d-flex align-items-flex-end justify-content-center py-3 px-2"
    >
      <div class="product-search-form__form-item">
        <label>Store <span>*</span></label>
        <store-selector
          :store.sync="form.storeId"
          class="store-select"
          @search="handleStoreSelectorSearch"
        />
      </div>

      <div class="product-search-form__form-item">
        <label>SKU <span>*</span></label>
        <el-input
          v-model.trim="form.skuId"
          clearable
          @keyup.enter.native="handleSearch"
        />
      </div>
      <el-button
        type="info"
        @click="handleSearch"
      >{{ $t('button.search') }}</el-button>
    </el-form>
  </div>
</template>

<script lang="ts">
import { createComponent, reactive, ref } from '@vue/composition-api'

import StoreSelector from '../../../components/StoreSelector.vue'

const ProductSearchBox = createComponent({
  components: {
    StoreSelector,
  },
  setup(_, { root, emit }) {
    const form = reactive({
      storeId: null,
      skuId: '',
    })
    const keywords = ref('')

    const handleSearch = () => {
      if (!form.storeId || !form.skuId) {
        root.$message.error('Please fill in both fields.')
        return
      }
      emit('search', {
        form: { ...form },
        keywords: keywords.value,
      })
    }

    const handleStoreSelectorSearch = (evt) => {
      keywords.value = evt.keywords
    }

    return {
      // Data
      form,

      // Methods
      handleSearch,
      handleStoreSelectorSearch,
    }
  },
})

export default ProductSearchBox
</script>

<style lang="scss" scoped>
.product-search-form {
  border: 2px solid #e7e7e7;
  border-radius: 4px;
  background: #fcfcfc;

  .el-form {
    > * {
      margin-left: 6px;
    }
  }

  ::v-deep {
    .el-input {
      max-width: 172px;

      input {
        height: 36px;
      }
    }
  }

  &__form-item {
    display: flex;
    flex-direction: column;

    label {
      font-size: 12px;

      span {
        color: #e74c3c;
      }
    }
  }

  .el-button {
    height: 36px;
  }
}
</style>
